import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f131fcb&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5f131fcb&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f131fcb')) {
      api.createRecord('5f131fcb', component.options)
    } else {
      api.reload('5f131fcb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5f131fcb&", function () {
      api.rerender('5f131fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/team/staff/index.vue"
export default component.exports